import { icons } from "assets/AssetHelper";
import * as dayjs from "dayjs";
import ColorRow from "components/Atoms/SharedComponents/Wrappers/Colors/ColorRow";

export const detailsData = ({ data, t }) => [
  {
    head: t("common.details"),
    icon: icons?.detailsIcon,
    details: [
      {
        label: t("wrappers_ribbon_colors.name_en"),
        name: data?.localized_data?.en?.name,
        width: "30%",
      },
      {
        label: t("wrappers_ribbon_colors.name_ar"),
        name: data?.localized_data?.ar?.name,
        width: "30%",
      },
      {
        label: t("wrappers_ribbon_colors.presentation"),
        name: <ColorRow data={data} />,
        width: "30%",
      },
      {
        label: t("wrappers_ribbon_colors.show_in_packaging"),
        name:
          data?.show_in_packaging === true
            ? t("common.yes")
            : data?.show_in_packaging === false
              ? t("common.no")
              : "-",
      },
      {
        label: t("wrappers_ribbon_colors.is_active"),
        name:
          data?.is_active === true
            ? t("common.yes")
            : data?.is_active === false
              ? t("common.no")
              : "-",
      },
      {
        label: t("wrappers_ribbon_colors.display_priority"),
        name: data?.display_priority ?? 0,
      },
    ],
  },
  {
    head: t("common.prices"),
    icon: icons?.priceIcon,
    details: [
      {
        label: t("wrappers_ribbon_colors.price"),
        name: `${data?.price} ${data?.currency?.name}`,
        width: "30%",
      },
      {
        label: t("wrappers_ribbon_colors.price_after_discount"),
        name: `${data?.price_after_discount} ${data?.currency?.name}`,
        width: "30%",
      },
    ],
  },
  {
    head: t("details.dates"),
    icon: icons.datesIcons,
    details: [
      {
        label: t("details.created_at"),
        name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("details.updated_at"),
        name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:MM a"),
      },
    ],
  },
];
